/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetAttributeDataSourcesPathParams = NonNullable<
  operations['getAttributeDataSources']['parameters']['path']
>;

export type GetAttributeDataSourcesQueryParams = NonNullable<
  operations['getAttributeDataSources']['parameters']['query']
>;

export interface Input extends GetAttributeDataSourcesPathParams {
  apiVersion?: string;
  query?: GetAttributeDataSourcesQueryParams;
}

export async function getAttributeDataSources(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projKey}/attribute-data-sources', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
